module.exports = __webpack_public_path__ + "bg_long.jpg?6022f46facb3fc64c78bcb3b006f0473";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/bg_long.jpg
// module id = 52
// module chunks = 0